import { Routes } from '@angular/router';

import { AccountComponent } from './pages/account/account.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ConfirmEmailComponent } from './pages/confirm-email/confirm-email.component';
import { ErrorComponent } from './pages/error/error.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { LoginComponent } from './pages/login/login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { RegisterComponent } from './pages/register/register.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

/**
 * Spring forwards the legacy URLs (/{lang}/{page}) to /auth-spa/index.html
 * so the SPA Router sees the original path. URL contract is unchanged.
 *
 * `lang` is validated inside each component (falls back to 'ru' if not ru/kz).
 */
export const routes: Routes = [
  { path: ':lang/login',           component: LoginComponent },
  { path: ':lang/account',         component: AccountComponent },
  { path: ':lang/register',        component: RegisterComponent },
  { path: ':lang/forgot-password', component: ForgotPasswordComponent },
  { path: ':lang/reset-password',  component: ResetPasswordComponent },
  { path: ':lang/change-password', component: ChangePasswordComponent },
  { path: ':lang/confirm-email',   component: ConfirmEmailComponent },
  { path: ':lang/error',           component: ErrorComponent },
  { path: '**', component: NotFoundComponent },
];
